module.exports = __webpack_public_path__ + "5bbfad3e37e5513a2e2aec63817a039c.jpg";